export const content = {
  cloud: ['Vielen Dank', 'Für Ihr Vertrauen!'],
  back: 'Zurück zum Start / neue Eingabe',
  customize: 'Berechnung anpassen / verändern',
  link: 'Mehr Informationen auf wienerberger.de',
}
